/** localStorage wrapper that never throws (private mode, blocked storage, quota). */
/** The playtest build at /playtest keeps its own progress, so playing ahead never touches the real streak or map. */
/** v2 since the restart (DECISIONS 2026-10-03 "Restart"): progress, streak and facts from the first run are ignored. */
export const PREFIX = import.meta.env.BASE_URL === "/" ? "whosteps:v2:" : "whosteps:playtest:v2:";
/** Keys from before the restart; deleted once on start so they don't linger. */
const OLD_PREFIXES = ["whosteps:v1:", "whosteps:playtest:v1:"];

/** Remove everything stored before the restart (one-off; never throws). */
export function dropOldKeys(ls: Storage | undefined = globalThis.localStorage): number {
  let n = 0;
  try {
    if (!ls) return 0;
    for (let i = ls.length - 1; i >= 0; i--) {
      const k = ls.key(i);
      if (k && OLD_PREFIXES.some((p) => k.startsWith(p))) {
        ls.removeItem(k);
        n++;
      }
    }
  } catch {
    /* storage blocked */
  }
  return n;
}

export const store = {
  get<T>(key: string): T | null {
    try {
      const v = localStorage.getItem(PREFIX + key);
      return v ? (JSON.parse(v) as T) : null;
    } catch {
      return null;
    }
  },
  set(key: string, value: unknown): void {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch {
      /* storage unavailable: play still works, progress isn't kept */
    }
  },
  del(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      /* ignore */
    }
  },
};
